import ClientList from './ClientList.vue';

export default ClientList;
